





























import { Component, Prop, Vue } from 'vue-property-decorator'

import { ListItem } from '@/layouts/components'

import { PaymentMethod } from '@/models'

@Component({
  components: {
    ListItem
  }
})
export default class PaymentMethodTile extends Vue {
  @Prop({ type: Object, required: true })
  readonly paymentMethod!: PaymentMethod
}
